import List from '@utils/list'
import Jurisdiction from '@utils/jurisdiction'
import Table from '@utils/table'
import Form from '@utils/form'
import { Options, Operation } from '@utils/index'
import { validatorStartMonth, validatorEndMonth } from './config/validator'
import { srmGeneralManually } from '@/api/achievements/index'

const options = new Options('performance.formulaConfig')
  .add('1', 'startUp')
  .add('2', 'notStart')

const dateAttrs = { format: 'yyyy-MM', type: 'month' }

const form = new Form('performance.formulaConfig')
  .setSpan(24)
  .add('statrtMonth').merge('date').attrs(dateAttrs).label('common.selectDate[0]').rules({ trigger: 'change', validator: validatorStartMonth }).required()
  .add('endMonth').merge('date').attrs(dateAttrs).label('common.selectDate[1]').rules({ trigger: 'change', validator: validatorEndMonth }).required()

async function implement(this: any, vm: any) {
  const { statrtMonth, endMonth } = vm.data
  await srmGeneralManually({ id: vm.row.id, statrtMonth, endMonth })
  this.search()
}
const operation = new Operation('performance.formulaConfig')
  .add('implement').form(form, implement, { width: '400px', title: 'common.selectDateTitle' })

const jurisdiction = new Jurisdiction()
  .lib('add').to('Performance.FormulaConfig.Add')
  .lib('modify').modify('Performance.FormulaConfig.Modify')
  .lib('delete').del('/srmGeneralFormula/deleteSrmGeneralFormulaByIds', process.env.VUE_APP_PURCHASE_API)

const table = new Table('performance.formulaConfig')
  .add('formulaName')
  .add('purOfficeNo').name('purOfficeName')
  .add('effectiveDate')
  .add('expirationDate')
  .add('lastExecutionTime').width(160)
  .add('rationFormulaName')
  .add('qualitativeWeight')
  .add('qualitativeFormulaName')
  .add('timingTaskStatus').op(options)
  .add('assessmentDate').format(({ value }) => `${table.vm.$t('performance.formulaConfig.monthly')}${value}${table.vm.$t('performance.formulaConfig.th')}`)

export default new List()
  .url('/srmGeneralFormula/getSrmGeneralFormulaPageByParams', process.env.VUE_APP_PURCHASE_API)
  .jurisdiction(jurisdiction)
  .operation(operation)
  .table(table)
  .end()
